// ЛАФЧЕ.ORG: чисто визуално "изчистване" на екрана (като /clear в shell) -
// НЕ маха съобщения от историята сървърно, само крие ги от текущия изглед
// докато не презаредиш страницата. WeakMap вместо канално поле, за да не
// пипаме споделения ClientChan/SharedChan тип. clearTrigger е нужен, защото
// WeakMap мутациите не са реактивни за Vue - без него computed() в
// MessageList.vue никога не би се преизчислил при /clear.
import {ref} from "vue";
import type {ClientChan} from "../types";

const clearedAtMap = new WeakMap<ClientChan, number>();
export const clearTrigger = ref(0);

export function clearChannelView(channel: ClientChan): void {
	clearedAtMap.set(channel, channel.messages.length);
	clearTrigger.value++;
}

export function getClearedIndex(channel: ClientChan): number {
	return clearedAtMap.get(channel) || 0;
}
